import { z } from 'zod';
import {
  DeclineCaseParams,
  OutcomeType,
  DispositionReasonType,
  DispositionSpecificationType,
  TurndownOutcome,
} from '@/api/apis/case';

export type DeclineCaseFormParams = Omit<DeclineCaseParams, 'turndownOutcome'> & {
  turndownOutcome?: TurndownOutcome | string;
};

export const declineCaseSchema = z.object({
  declineReason: z.enum(OutcomeType),
  dispositionReason: z.enum(DispositionReasonType),
  dispositionSpecification: z.enum(DispositionSpecificationType),
  turndownOutcome: z.union([z.enum(TurndownOutcome), z.string().min(0)]),
  dispositionComment: z.string().max(1024, { error: 'Maximum 1024 characters' }),
  timeZone: z.string(),
  timestamp: z.string(),
});
